import Styled from 'styled-components';

// A custom field value shown in a design-system hover box. Admin-typed values can be one long unbroken
// string, which the box's fixed width cannot wrap, so the text would run out of it; this lets it break
// anywhere so it always wraps inside.
export const CustomFieldTooltipText = Styled.span`
	display: block;
	overflow-wrap: anywhere;
	word-break: break-word;
`;
